

// $(document).ready(function () {
  
//   $(window).scroll(function (event) {
//     var height = $(window).height();
//     var scroll = $(window).scrollTop();
//       if(scroll > height){
//         $(".sticky-header").addClass("show");
//       } else {
//         $(".sticky-header").removeClass("show");
//       } 
//   });
  
//   // bundle form id handling
//   const form = $('#flexi-box-bundle-form');
//   // fetch total steps from data attribute
//   const totalSteps = parseInt(form.data('total-steps'));
//   // current step tracker
//   let currentStep = 1;
//   // step selections object
//   const stepSelections = {};
  
//   // Initialize step selections storage
//   for (let i = 1; i <= totalSteps; i++) {
//     stepSelections[i] = [];
//   }
  
//   // Tab click handler - UPDATED to allow navigation to any step
//   $('.bundle-tab').click(function() {
//     // Get the target step from the clicked tab's data attribute
//     const targetStep = parseInt($(this).data('step'));
    
//     // Allow navigation to ANY step (removed restriction)
//     changeStep(targetStep);
//   });
  
//   // Function to change step
//   function changeStep(stepNumber) {
//     currentStep = stepNumber;
    
//     // Update active step content
//     $('.bundle-step').removeClass('active');
//     $(`.bundle-step[data-step="${stepNumber}"]`).addClass('active');
    
//     // Update active tab
//     $('.bundle-tab').removeClass('active');
//     $(`.bundle-tab[data-step="${stepNumber}"]`).addClass('active');
    
//     // Check if all steps are completed
//     checkAllStepsCompleted();
//   }
  
//   // Handle checkbox changes for each step
//   for (let step = 1; step <= totalSteps; step++) {
//     const stepCheckboxes = $(`.bundle-product-checkbox[data-step="${step}"]`);
//     const maxAllowed = $(`#checkboxes-bundle-${step}`).attr("max_allowed");
    
//     stepCheckboxes.click(function () {
//       var n = $(`.bundle-product-checkbox[data-step="${step}"]:checked`).length;
      
//       console.log(`Step ${step} - Checked:`, n, 'Max:', maxAllowed);
      
//       // Update counter
//       if(n>0){
//         $(`#bundle-checkbox-count-${step}`).css("display", "inline-block");
//         $(`#bundle-checkbox-count-${step}`).html(n);
//       }
//       else{
//         $(`#bundle-checkbox-count-${step}`).css("display", "none");
//       }
      
//       // Disable unchecked items if max reached
//       $.each(stepCheckboxes, function () {
//         if (!$(this).is(":checked") && n == maxAllowed) {
//           $(this).prop("disabled", true);
//         } else {
//           $(this).prop("disabled", false);
//         }
//       });
      
//       // Store selections for this step
//       stepSelections[step] = [];
//       stepCheckboxes.filter(':checked').each(function() {
//         stepSelections[step].push({
//           sku: $(this).data('sku'),
//           price: $(this).data('price'),
//           title: $(this).data('product-title'),
//           variantId: $(this).data('variant-id'),
//           mrp: $(this).data('mrp')
//         });
//       });
      
//       // If max reached for this step
//       if (n == maxAllowed) {
//         // Mark tab as completed
//         $(`.bundle-tab[data-step="${step}"]`).addClass('completed');
        
//         // Auto-navigate to next step after 1 second
//         if (step < totalSteps) {
//           setTimeout(function() {
//             changeStep(step + 1);
//           }, 1000);
//         }
//       } else {
//         // Remove completed status if deselecting
//         $(`.bundle-tab[data-step="${step}"]`).removeClass('completed');
//       }
      
//       // Check if all steps completed
//       checkAllStepsCompleted();
//     });
//   }
  
//   // Function to check if all steps are completed
//   function checkAllStepsCompleted() {
//     let allCompleted = true;
    
//     for (let i = 1; i <= totalSteps; i++) {
//       const maxAllowed = parseInt($(`#checkboxes-bundle-${i}`).attr("max_allowed"));
//       const selected = stepSelections[i].length;
      
//       if (selected !== maxAllowed) {
//         allCompleted = false;
//         break;
        
//       }
//     }

//     // Show/hide submit button
//     if (allCompleted) {
//       $('#bundle-submit-btn').css("display", "inline-block");
//     } else {
//       $('#bundle-submit-btn').css("display", "none");
//     }
    
//     return allCompleted;
//   }
  
//   // Handle form submission
//   form.submit(function (e) {
//     form
//       .find(":input")
//       .each(function () {
//         if ($(this).val() == "No") {
//           $(this).prop("disabled", true);
//         }
//       });
//   });
  
// });

// // json format change by Anshika Arora 
// document.addEventListener('DOMContentLoaded', function () {
  
//   const form = document.querySelector('#flexi-box-bundle-form');
//   const totalSteps = parseInt(form.dataset.totalSteps);
//   const dynamicPropertiesContainer = document.querySelector('#bundle-dynamic-properties');
  
//   //fetch byob parent info 
//   const byobParentSku = form.dataset.byobParentSku;
//   const parentPrice = parseFloat(form.dataset.byobParentPrice);
  
//   console.log('BYOB Parent SKU:', byobParentSku);
//   console.log('Parent Price:', parentPrice);
//   console.log('Total Steps:', totalSteps);

//   function updateProportionalPrices() {
//     dynamicPropertiesContainer.innerHTML = '';

//     // Collect ALL selections from ALL steps
//     let allSelections = [];
    
//     for (let step = 1; step <= totalSteps; step++) {
//       const stepCheckboxes = document.querySelectorAll(`.bundle-product-checkbox[data-step="${step}"]:checked`);
      
//       stepCheckboxes.forEach(cb => {
//         allSelections.push({
//           sku: cb.dataset.sku,
//           price: parseFloat(cb.dataset.price || 0),
//           title: cb.dataset.productTitle,
//           variantId: cb.dataset.variantId,
//           mrp: parseFloat(cb.dataset.mrp || 0)
//         });
//       });
//     }
    
//     console.log('All selections from all steps:', allSelections);
    
//     if (allSelections.length === 0) return;

//     // Calculate total regular price using ALL selections
//     const totalRegularPrice = allSelections.reduce((sum, item) => {
//       return sum + item.price;
//     }, 0);

//     console.log('Total Regular Price (all steps):', totalRegularPrice);

//     const parentQuantity = 1;

//     // Create _bundle_product1 (parent BYOB product)
//     const bundleProduct1 = document.createElement('input');
//     bundleProduct1.type = 'hidden';
//     bundleProduct1.name = 'properties[_bundle_product1]';
//     bundleProduct1.value = `${byobParentSku}/0/${parentQuantity}`;
//     dynamicPropertiesContainer.appendChild(bundleProduct1);

//     // Create all _bundle_product properties for ALL selected products
//     allSelections.forEach((item, index) => {
//       const proportionalPrice = parseFloat(((item.price / totalRegularPrice) * parentPrice).toFixed(2));
      
//       console.log(`Item ${index + 1}:`, { 
//         sku: item.sku, 
//         price: item.price, 
//         proportionalPrice 
//       });
      
//       const bundleInput = document.createElement('input');
//       bundleInput.type = 'hidden';
//       bundleInput.name = `properties[_bundle_product${index + 2}]`;
//       bundleInput.value = `${item.sku}/${proportionalPrice}/1`;
//       dynamicPropertiesContainer.appendChild(bundleInput);
//     });
    
//     console.log('Generated properties:', dynamicPropertiesContainer.innerHTML);
//   }

//   // Add change listeners to all checkboxes
//   const allCheckboxes = document.querySelectorAll('.bundle-product-checkbox');
//   allCheckboxes.forEach((checkbox) => {
//     checkbox.addEventListener('change', updateProportionalPrices);
//   });

//   // Update properties before form submission
//   form.addEventListener('submit', function(e) {
//     updateProportionalPrices();
    
//     const formData = new FormData(form);
//     console.log('=== Form Data Being Submitted ===');
//     for (let [key, value] of formData.entries()) {
//       console.log(key, ':', value);
//     }

//   });
// });



$(document).ready(function () {
  
  $(window).scroll(function (event) {
    var height = $(window).height();
    var scroll = $(window).scrollTop();
      if(scroll > height){
        $(".sticky-header").addClass("show");
      } else {
        $(".sticky-header").removeClass("show");
      } 
  });
  
  // bundle form id handling
  const form = $('#flexi-box-bundle-form');
  // fetch total steps from data attribute
  const totalSteps = parseInt(form.data('total-steps'));
  // current step tracker
  let currentStep = 1;
  // step selections object
  const stepSelections = {};
  
  // Initialize step selections storage
  for (let i = 1; i <= totalSteps; i++) {
    stepSelections[i] = [];
  }
  
  // Tab click handler
  $('.bundle-tab').click(function() {
    // Get the target step from the clicked tab's data attribute
    const targetStep = parseInt($(this).data('step'));
    
    // Allow navigation to completed steps or current step
    if ($(this).hasClass('completed') || targetStep === currentStep) {
      changeStep(targetStep);
    }
  });
  
  // Function to change step
  function changeStep(stepNumber) {
    currentStep = stepNumber;
    
    // Update active step content
    $('.bundle-step').removeClass('active');
    $(`.bundle-step[data-step="${stepNumber}"]`).addClass('active');
    
    // Update active tab
    $('.bundle-tab').removeClass('active');
    $(`.bundle-tab[data-step="${stepNumber}"]`).addClass('active');
    
    // Scroll to top
    $('html, body').animate({
      scrollTop: $('.bundle-tabs-container').offset().top - 20
    }, 300);
    
    // Check if all steps are completed
    checkAllStepsCompleted();
  }
  
  // Handle checkbox changes for each step
  for (let step = 1; step <= totalSteps; step++) {
    const stepCheckboxes = $(`.bundle-product-checkbox[data-step="${step}"]`);
    const maxAllowed = $(`#checkboxes-bundle-${step}`).attr("max_allowed");
    
    stepCheckboxes.click(function () {
      var n = $(`.bundle-product-checkbox[data-step="${step}"]:checked`).length;
      
      console.log(`Step ${step} - Checked:`, n, 'Max:', maxAllowed);
      
      // Update counter
      if(n>0){
        $(`#bundle-checkbox-count-${step}`).css("display", "inline-block");
        $(`#bundle-checkbox-count-${step}`).html(n);
      }
      else{
        $(`#bundle-checkbox-count-${step}`).css("display", "none");
      }
      
      // Disable unchecked items if max reached
      $.each(stepCheckboxes, function () {
        if (!$(this).is(":checked") && n == maxAllowed) {
          $(this).prop("disabled", true);
        } else {
          $(this).prop("disabled", false);
        }
      });
      
      // Store selections for this step
      stepSelections[step] = [];
      stepCheckboxes.filter(':checked').each(function() {
        stepSelections[step].push({
          sku: $(this).data('sku'),
          price: $(this).data('price'),
          title: $(this).data('product-title'),
          variantId: $(this).data('variant-id'),
          mrp: $(this).data('mrp')
        });
      });
      
      // If max reached for this step
      if (n == maxAllowed) {
        // Mark tab as completed
        $(`.bundle-tab[data-step="${step}"]`).addClass('completed');
        
        // Auto-navigate to next step after 1 second
        if (step < totalSteps) {
          setTimeout(function() {
            changeStep(step + 1);
          }, 1000);
        }
      } else {
        // Remove completed status if deselecting
        $(`.bundle-tab[data-step="${step}"]`).removeClass('completed');
      }
      
      // Check if all steps completed
      checkAllStepsCompleted();
    });
  }
  
  // Function to check if all steps are completed
  function checkAllStepsCompleted() {
    let allCompleted = true;
    
    for (let i = 1; i <= totalSteps; i++) {
      const maxAllowed = parseInt($(`#checkboxes-bundle-${i}`).attr("max_allowed"));
      const selected = stepSelections[i].length;
      
      if (selected !== maxAllowed) {
        allCompleted = false;
        break;
        
      }
    }

    // Show/hide submit button
    if (allCompleted) {
      $('#bundle-submit-btn').css("display", "inline-block");
    } else {
      $('#bundle-submit-btn').css("display", "none");
    }
    
    return allCompleted;
  }
  
  // Handle form submission
  form.submit(function (e) {
    form
      .find(":input")
      .each(function () {
        if ($(this).val() == "No") {
          $(this).prop("disabled", true);
        }
      });
  });
  
});

// json format change by Anshika Arora 
document.addEventListener('DOMContentLoaded', function () {
  
  const form = document.querySelector('#flexi-box-bundle-form');
  const totalSteps = parseInt(form.dataset.totalSteps);
  const dynamicPropertiesContainer = document.querySelector('#bundle-dynamic-properties');
  
  //fetch byob parent info 
  const byobParentSku = form.dataset.byobParentSku;
  const parentPrice = parseFloat(form.dataset.byobParentPrice);
  
  console.log('BYOB Parent SKU:', byobParentSku);
  console.log('Parent Price:', parentPrice);
  console.log('Total Steps:', totalSteps);

  function updateProportionalPrices() { 
    dynamicPropertiesContainer.innerHTML = '';

    // Collect ALL selections from ALL steps
    let allSelections = [];
    
    for (let step = 1; step <= totalSteps; step++) {
      const stepCheckboxes = document.querySelectorAll(`.bundle-product-checkbox[data-step="${step}"]:checked`);
      
      stepCheckboxes.forEach(cb => {
        allSelections.push({
          sku: cb.dataset.sku,
          price: parseFloat(cb.dataset.price || 0),
          title: cb.dataset.productTitle,
          variantId: cb.dataset.variantId,
          mrp: parseFloat(cb.dataset.mrp || 0)
        });
      });
    }
    
    console.log('All selections from all steps:', allSelections);
    
    if (allSelections.length === 0) return;

    // Calculate total regular price using ALL selections
    const totalRegularPrice = allSelections.reduce((sum, item) => {
      return sum + item.price;
    }, 0);

    console.log('Total Regular Price (all steps):', totalRegularPrice);

    const parentQuantity = 1;

    // Create _bundle_product1 (parent BYOB product)
    const bundleProduct1 = document.createElement('input');
    bundleProduct1.type = 'hidden';
    bundleProduct1.name = 'properties[_bundle_product1]';
    bundleProduct1.value = `${byobParentSku}/0/${parentQuantity}`;
    dynamicPropertiesContainer.appendChild(bundleProduct1);

    // Create all _bundle_product properties for ALL selected products
    allSelections.forEach((item, index) => {
      const proportionalPrice = parseFloat(((item.price / totalRegularPrice) * parentPrice).toFixed(2));
      
      console.log(`Item ${index + 1}:`, { 
        sku: item.sku, 
        price: item.price, 
        proportionalPrice 
      });
      
      const bundleInput = document.createElement('input');
      bundleInput.type = 'hidden';
      bundleInput.name = `properties[_bundle_product${index + 2}]`;
      bundleInput.value = `${item.sku}/${proportionalPrice}/1`;
      dynamicPropertiesContainer.appendChild(bundleInput);
    });
    
    console.log('Generated properties:', dynamicPropertiesContainer.innerHTML);
  }

  // Add change listeners to all checkboxes
  const allCheckboxes = document.querySelectorAll('.bundle-product-checkbox');
  allCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateProportionalPrices);
  });

  // Add click handler to disable button after 1000ms
  const submitBtn = document.getElementById('bundle-submit-btn');
  if (submitBtn) {
    submitBtn.addEventListener('click', function() {
      const btn = this;
      setTimeout(function() {
        btn.disabled = true;
        btn.setAttribute('disabled', 'disabled');
        
        // Fallback: Re-enable after 3 seconds if no cart event fires
        setTimeout(function() {
          console.log('Fallback timeout - re-enabling button');
          btn.disabled = false;
          btn.removeAttribute('disabled');
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
          btn.textContent = 'ADD TO CART';
        }, 3000);
      }, 1000);
    });
  }

  // Function to re-enable button
  function reEnableButton() {
    const btn = document.getElementById('bundle-submit-btn');
    if (btn) {
      console.log('Re-enabling button');
      btn.disabled = false;
      btn.removeAttribute('disabled');
      btn.style.opacity = '1';
      btn.style.cursor = 'pointer';
      btn.textContent = 'ADD TO CART';
    }
  }

  // Listen for various cart events
  $(document).on('cart.requestComplete', reEnableButton);
  document.addEventListener('ajaxCart.afterCartAdd', reEnableButton);
  $(document).on('ajaxProduct:added', reEnableButton);
  window.addEventListener('cart:item-added', reEnableButton);

  // Update properties before form submission
  form.addEventListener('submit', function(e) {
    updateProportionalPrices();
    
    const formData = new FormData(form);
    console.log('=== Form Data Being Submitted ===');
    for (let [key, value] of formData.entries()) {
      console.log(key, ':', value);
    }
  });
});

$(document).ready(function () {
  
  $(window).scroll(function (event) {
    var height = $(window).height();
    var scroll = $(window).scrollTop();
      if(scroll > height){
        $(".sticky-header").addClass("show");
      } else {
        $(".sticky-header").removeClass("show");
      } 
  });
  
  // bundle form id handling
  const form = $('#flexi-box-bundle-form');
  // fetch total steps from data attribute
  const totalSteps = parseInt(form.data('total-steps'));
  // current step tracker
  let currentStep = 1;
  // step selections object
  const stepSelections = {};
  
  // Initialize step selections storage
  for (let i = 1; i <= totalSteps; i++) {
    stepSelections[i] = [];
  }
  
  // Tab click handler - UPDATED to allow navigation to any step
  $('.bundle-tab').click(function() {
    // Get the target step from the clicked tab's data attribute
    const targetStep = parseInt($(this).data('step'));
    
    // Allow navigation to ANY step (removed restriction)
    changeStep(targetStep);
  });
  

  // Function to change step
  function changeStep(stepNumber) {
    currentStep = stepNumber;
    
    // Update active step content
    $('.bundle-step').removeClass('active');
    $(`.bundle-step[data-step="${stepNumber}"]`).addClass('active');
    
    // Update active tab
    $('.bundle-tab').removeClass('active');
    $(`.bundle-tab[data-step="${stepNumber}"]`).addClass('active');
    
    // Check if all steps are completed
    checkAllStepsCompleted();
  }
  
  // Handle checkbox changes for each step
  for (let step = 1; step <= totalSteps; step++) {
    const stepCheckboxes = $(`.bundle-product-checkbox[data-step="${step}"]`);
    const maxAllowed = $(`#checkboxes-bundle-${step}`).attr("max_allowed");
    
    stepCheckboxes.click(function () {
      var n = $(`.bundle-product-checkbox[data-step="${step}"]:checked`).length;
      
      console.log(`Step ${step} - Checked:`, n, 'Max:', maxAllowed);
      
      // Update counter
      if(n>0){
        $(`#bundle-checkbox-count-${step}`).css("display", "inline-block");
        $(`#bundle-checkbox-count-${step}`).html(n);
      }
      else{
        $(`#bundle-checkbox-count-${step}`).css("display", "none");
      }
      
      // Disable unchecked items if max reached
      $.each(stepCheckboxes, function () {
        if (!$(this).is(":checked") && n == maxAllowed) {
          $(this).prop("disabled", true);
        } else {
          $(this).prop("disabled", false);
        }
      });
      
      // Store selections for this step
      stepSelections[step] = [];
      stepCheckboxes.filter(':checked').each(function() {
        stepSelections[step].push({
          sku: $(this).data('sku'),
          price: $(this).data('price'),
          title: $(this).data('product-title'),
          variantId: $(this).data('variant-id'),
          mrp: $(this).data('mrp')
        });
      });
      
      // If max reached for this step
      if (n == maxAllowed) {
        // Mark tab as completed
        $(`.bundle-tab[data-step="${step}"]`).addClass('completed');
        
        // Auto-navigate to next step after 1 second
        if (step < totalSteps) {
          setTimeout(function() {
            changeStep(step + 1);
          }, 1000);
        }
      } else {
        // Remove completed status if deselecting
        $(`.bundle-tab[data-step="${step}"]`).removeClass('completed');
      }
      
      // Check if all steps completed
      checkAllStepsCompleted();
    });
  }
  
  // Function to check if all steps are completed
  function checkAllStepsCompleted() {
    let allCompleted = true;
    
    for (let i = 1; i <= totalSteps; i++) {
      const maxAllowed = parseInt($(`#checkboxes-bundle-${i}`).attr("max_allowed"));
      const selected = stepSelections[i].length;
      
      if (selected !== maxAllowed) {
        allCompleted = false;
        break;
        
      }
    }

    // Show/hide submit button
    if (allCompleted) {
      $('#bundle-submit-btn').css("display", "inline-block");
    } else {
      $('#bundle-submit-btn').css("display", "none");
    }
    
    return allCompleted;
  }
  
  // Handle form submission
  form.submit(function (e) {
    form
      .find(":input")
      .each(function () {
        if ($(this).val() == "No") {
          $(this).prop("disabled", true);
        }
      });
  });
  
});

// json format change by Anshika Arora 
document.addEventListener('DOMContentLoaded', function () {
  
  const form = document.querySelector('#flexi-box-bundle-form');
  const totalSteps = parseInt(form.dataset.totalSteps);
  const dynamicPropertiesContainer = document.querySelector('#bundle-dynamic-properties');
  
  //fetch byob parent info 
  const byobParentSku = form.dataset.byobParentSku;
  const parentPrice = parseFloat(form.dataset.byobParentPrice);
  
  console.log('BYOB Parent SKU:', byobParentSku);
  console.log('Parent Price:', parentPrice);
  console.log('Total Steps:', totalSteps);

  function updateProportionalPrices() {
    dynamicPropertiesContainer.innerHTML = '';

    // Collect ALL selections from ALL steps
    let allSelections = [];
    
    for (let step = 1; step <= totalSteps; step++) {
      const stepCheckboxes = document.querySelectorAll(`.bundle-product-checkbox[data-step="${step}"]:checked`);
      
      stepCheckboxes.forEach(cb => {
        allSelections.push({
          sku: cb.dataset.sku,
          price: parseFloat(cb.dataset.price || 0),
          title: cb.dataset.productTitle,
          variantId: cb.dataset.variantId,
          mrp: parseFloat(cb.dataset.mrp || 0)
        });
      });
    }
    
    console.log('All selections from all steps:', allSelections);
    
    if (allSelections.length === 0) return;

    // Calculate total regular price using ALL selections
    const totalRegularPrice = allSelections.reduce((sum, item) => {
      return sum + item.price;
    }, 0);

    console.log('Total Regular Price (all steps):', totalRegularPrice);

    const parentQuantity = 1;

    // Create _bundle_product1 (parent BYOB product)
    const bundleProduct1 = document.createElement('input');
    bundleProduct1.type = 'hidden';
    bundleProduct1.name = 'properties[_bundle_product1]';
    bundleProduct1.value = `${byobParentSku}/0/${parentQuantity}`;
    dynamicPropertiesContainer.appendChild(bundleProduct1);

    // Create all _bundle_product properties for ALL selected products
    allSelections.forEach((item, index) => {
      const proportionalPrice = parseFloat(((item.price / totalRegularPrice) * parentPrice).toFixed(2));
      
      console.log(`Item ${index + 1}:`, { 
        sku: item.sku, 
        price: item.price, 
        proportionalPrice 
      });
      
      const bundleInput = document.createElement('input');
      bundleInput.type = 'hidden';
      bundleInput.name = `properties[_bundle_product${index + 2}]`;
      bundleInput.value = `${item.sku}/${proportionalPrice}/1`;
      dynamicPropertiesContainer.appendChild(bundleInput);
    });
    
    console.log('Generated properties:', dynamicPropertiesContainer.innerHTML);
  }

  // Add change listeners to all checkboxes
  const allCheckboxes = document.querySelectorAll('.bundle-product-checkbox');
  allCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', updateProportionalPrices);
  });

  // Add click handler to disable button after 1000ms
  const submitBtn2 = document.getElementById('bundle-submit-btn');
  if (submitBtn2) {
    submitBtn2.addEventListener('click', function() {
      const btn = this;
      setTimeout(function() {
        btn.disabled = true;
        btn.setAttribute('disabled', 'disabled');
        
        // Fallback: Re-enable after 3 seconds if no cart event fires
        setTimeout(function() {
          console.log('Fallback timeout (handler 2) - re-enabling button');
          btn.disabled = false;
          btn.removeAttribute('disabled');
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
          btn.textContent = 'ADD TO CART';
        }, 2500);
      }, 50);
    });
  }

  // if product added to cart, re-enable button
  function reEnableButton2() {
    //check atc event fired
    const btn = document.getElementById('bundle-submit-btn');
    if (btn) {
      console.log('Re-enabling button (handler 2)');
      btn.disabled = false;
      btn.removeAttribute('disabled');
      btn.style.opacity = '1';
      btn.style.cursor = 'pointer';
      btn.textContent = 'ADD TO CART';
      
    }
  }
  

  // Listen for various cart events
  $(document).on('cart.requestComplete', reEnableButton2);
  document.addEventListener('ajaxCart.afterCartAdd', reEnableButton2);
  $(document).on('ajaxProduct:added', reEnableButton2);
  window.addEventListener('cart:item-added', reEnableButton2);

  // Update properties before form submission
  form.addEventListener('submit', function(e) {
    updateProportionalPrices();
    
    const formData = new FormData(form);
    console.log('=== Form Data Being Submitted ===');
    for (let [key, value] of formData.entries()) {
      console.log(key, ':', value);
    }
  });
});